import PubSub from 'pubsub-js'
import { meshLog, SPGet, SPSet } from "./spUtils";
import { transIntTo2Str } from "./dataUtils";
import { getNameBygroupID } from "./meshUtils";
import { sendOpcode_schedule_state } from "./opcodeUtils";
import { uploadNewScheduleData } from "./net/netUtils";
import { Opcode_delete, Opcode_edit, SET_Emergency_DIALOG_HIDE } from "../const/infoConst";

//----------------------------------- 普通定时--------------------------------------------
//新建定时
export const addNewSchedule = () => {
    let sceneMode=parseInt('1001', 16);
    let sche={"name":"","time":600,"sceneID":getSceneId(),"sceneMode":sceneMode,"sceneValue":0,"groupIDs":[],"repeatMode":0,"repeatWeek":0,"isAdd":true};
    SPSet("edit_schedule", JSON.stringify(sche));
    saveWeekQuestInfo(0,0);
    meshLog('wjk add schedule', sche);
}

export const editEditSchedule = (mId) => {
    let list = JSON.parse(SPGet("sceneList"))
    for(let i=0;i<list.length;i++){
        if(list[i].sceneID==mId){
            let sche={"name":list[i].name,"time":list[i].time,"sceneID":mId,"sceneMode":list[i].sceneMode,"sceneValue":list[i].sceneValue,"groupIDs":list[i].groupIDs,"repeatMode":list[i].repeatMode,"repeatWeek":list[i].repeatWeek,"isAdd":false};
            SPSet("edit_schedule", JSON.stringify(sche));
            let type=getSceneType(sche.sceneMode);
            saveWeekQuestInfo(type,getMultiValueNum(type,sche.sceneValue));
            meshLog('wjk edit schedule', sche);
            return;
        }
    }
}


//保存新定时
export const saveScheduleInfo = (name,time,group,repeat,w1,w2,w3,w4,w5,w6,w7,isAdd,sceneID) => {
    let sche = JSON.parse(SPGet("edit_schedule"))
    let json = JSON.parse(SPGet("temp_scene"))
    sche.name=name;
    sche.time=time;
    sche.sceneID=sceneID;
    sche.sceneMode=json.model;
    sche.sceneValue=json.value;
    sche.groupIDs=group;
    sche.repeatMode=w1*1 + w2*2 + w3*4 + w4*8 + w5*16 + w6*32 + w7*64 +repeat*128; //依照App来
    sche.repeatWeek=0; 

    let list = JSON.parse(SPGet("sceneList"))
    if(isAdd){
        list[list.length]=sche;
    }else{
        for(let i=0;i<list.length;i++){
            if(list[i].sceneID==sceneID){
                list[i]=sche;
            }
        }
    }
    sendOpcode_schedule_state(sche,Opcode_edit);
    uploadNewScheduleData(list);
}

//删除定时
export const delScheduleInfo = () => {
    let sche = JSON.parse(SPGet("edit_schedule"))
    let list = JSON.parse(SPGet("sceneList"))

    meshLog('wjk 删除定时', sche);

    let arr=[];
    let count=0;
    for(let i=0;i<list.length;i++){
        if(list[i].sceneID==sche.sceneID){
            //待删除
        }else{
            arr[count]=list[i];
            count++
        }
    }
    sendOpcode_schedule_state(sche,Opcode_delete);
    uploadNewScheduleData(arr);
}

//获取定时列表信息
export const getScheduleShowInfo = () => {
    let sche = JSON.parse(SPGet("sceneList"))
    
    let arr=[]
    let count=0;
    for(let i=0;i<sche.length;i++){
        if(sche[i].sceneMode!=parseInt('10D1', 16)){ 
            let type=getSceneType(sche[i].sceneMode);
            let quest=getQuestInfo(type,getMultiValueNum(type,sche[i].sceneValue));
            quest="Quest: "+quest.replace(': ','_');
            arr[count]={"id":sche[i].sceneID,"name":sche[i].name,"time":getTimeStr(sche[i].time),"quest":quest,"week":getWeekStr(sche[i].repeatMode),"group":getGroupStr(sche[i].groupIDs)};
            count++;
        }
    }
    meshLog('wjk 定时列表', arr);
    return arr;
}

function getWeekStr(info){
    let msg="";
    let w1=0;
    let w2=0;
    let w3=0;
    let w4=0;
    let w5=0;
    let w6=0;
    let w7=0;

    if (parseInt(info%2)>=1) {
        w1 = 1;
        msg="Mo ";
    }
    if (parseInt((info%4)/2)>=1) {
        w2 = 1;
        msg += "Tu ";
    }
    if (parseInt((info%8)/4)>=1) {
        w3 = 1;
        msg += "We ";
    }
    if (parseInt((info%16)/8)>=1) {
        w4 = 1;
        msg += "Th ";
    }
    if (parseInt((info%32)/16)>=1) {
        w5 = 1;
        msg += "Fr ";
    }
    if (parseInt((info%64)/32)>=1) {
        w6 = 1;
        msg += "Sa ";
    }
    if (parseInt((info%128)/64)>=1) {
        w7 = 1;
        msg += "Su ";
    }
    return msg.length>0?("Repeat: "+msg):"";
}

function getGroupStr(arr){
    let msg="";
    for (let j = 0; j < arr.length; j++) {
        msg = msg + getNameBygroupID(arr[j]) + " ";
    }
    return msg.length>0?("Associated Group: "+msg):"";
}
function getTimeStr(time){
    let msg="";
    let mH=parseInt(time/60);
    if(mH<13){
        msg="Time: "+mH+":"+transIntTo2Str(time%60)+" AM UTC";
    }else{
        mH=mH-12;
        msg="Time: "+mH+":"+transIntTo2Str(time%60)+" PM UTC";    
    }
    return msg;
}


//获取场景描述
export const getWeekQuestDesc = () => {
    let json = JSON.parse(SPGet("temp_scene"))
    return json.info
}

//更改场景Quest
export const saveWeekQuestInfo = (type,value) => {
    let sceneMode=getSceneMode(type);
    let sceneValue=getSceneValueNum(type,value);
    let questInfo=getQuestInfo(type,value);

    let temp={"model":sceneMode,"value":sceneValue,"info":questInfo};
    SPSet("temp_scene", JSON.stringify(temp));
}
function getSceneMode(type){
    let sceneMode=0;
    if(type==0){
        sceneMode=parseInt('1001', 16);
    }else if(type==1){
        sceneMode=parseInt('1031', 16);
    }else if(type==2){
        sceneMode=parseInt('1011', 16);
    }else if(type==3){
        sceneMode=parseInt('1021', 16); //数值2个字节
    }else if(type==4){
        sceneMode=parseInt('1041', 16);
    }else if(type==5){
        sceneMode=parseInt('1051', 16);
    }else if(type==6){
        sceneMode=parseInt('1061', 16); //数值2个字节
    }else if(type==7){
        sceneMode=parseInt('1071', 16);
    }else if(type==8){
        sceneMode=parseInt('1081', 16);
    }else if(type==9){
        sceneMode=parseInt('1091', 16);
    }
    return sceneMode;
}
function getSceneType(sceneMode){
    let type=0;
    if(sceneMode==parseInt('1001', 16)){
        type=0;
    }else if(sceneMode==parseInt('1031', 16)){
        type=1;
    }else if(sceneMode==parseInt('1011', 16)){
        type=2;
    }else if(sceneMode==parseInt('1021', 16)){
        type=3;
    }else if(sceneMode==parseInt('1041', 16)){
        type=4;
    }else if(sceneMode==parseInt('1051', 16)){
        type=5;
    }else if(sceneMode==parseInt('1061', 16)){
        type=6;
    }else if(sceneMode==parseInt('1071', 16)){
        type=7;
    }else if(sceneMode==parseInt('1081', 16)){
        type=8;
    }else if(sceneMode==parseInt('1091', 16)){
        type=9;
    }
    return type;
}

function getSceneValueNum(type,value){
    let sceneValue=0;
    if(type==0){
        sceneValue=value;
    }else if(type==1){
        sceneValue=value;
    }else if(type==2){
        sceneValue=value;
    }else if(type==3){
        sceneValue=value;
    }else if(type==4){
        sceneValue=value;
    }else if(type==5){
        sceneValue=value+1;
    }else if(type==6){
        if(value==0){
            sceneValue=5;
        }else if(value==1){
            sceneValue=30;
        }else{
            sceneValue=(value-1)*60;
        }
    }else if(type==7){
        sceneValue=value;        
    }else if(type==8){
        if(value==0){
            sceneValue=0;
        }else if(value==1){
            sceneValue=5;
        }else if(value==2){
            sceneValue=30;
        }else if(value<=122){
            sceneValue=(value-1)*60;
        }else{
            sceneValue=65535;
        }
    }else if(type==9){
        sceneValue=(value+1)*50;
    }
    return sceneValue;
}

function getMultiValueNum(type,sceneValue){
    let value=0;
    if(type<=4){
        value=sceneValue;
    }else if(type==5){
        value=sceneValue-1;
    }else if(type==6){
        if(sceneValue==5){
            value=0;
        }else if(sceneValue==30){
            value=1;
        }else{
            value=parseInt(sceneValue/60)+1;
        }
    }else if(type==7){
        value=sceneValue;
    }else if(type==8){
        if(sceneValue==0){
            value=0;
        }else if(sceneValue==5){
            value=1;
        }else if(sceneValue==30){
            value=2;
        }else if(sceneValue<=(121*60)){
            value=parseInt(sceneValue/60)+1;
        }else{
            value=123;
        }
    }else if(type==9){
        value=parseInt(sceneValue/50)-1;
    }
    return value;
}

function getQuestInfo(type,value){
    let info="";
    if(type==0){
        info="ON/OFF_ "+(value==1?"ON":"OFF");
    }else if(type==1){
        info="Sensor Mode: "+(value==2?"Vacant":(value==1?"ON":"OFF"));
    }else if(type==2){
        info="Dim Level: "+value+"%";
    }else if(type==3){
        info="CCT Tunable: "+value;
    }else if(type==4){
        info="Detection Area: "+(value==2?"High":(value==1?"Medium":"Low"));
    }else if(type==5){
        info="Max Dim: "+(value+1)+"%";;
    }else if(type==6){
        info="HoldTime: "+getArrSetInfo(getHoldTime(),value);
    }else if(type==7){
        info="Standby Dim Level: "+getArrSetInfo(getStandbyDim(),value);      
    }else if(type==8){
        info="Standby Period: "+getArrSetInfo(getStandbyPeriod(),value);    
    }else if(type==9){
        info="Daylight Threshold: "+getArrSetInfo(getDaylightThresholdLux(),value);   
    }

    return info;
}

function getArrSetInfo(arr,value){
    let info="";
    for (let i = 0; i < arr.length; i++) {
        if(i==value){
            info=arr[i].label;
        }
    }
    // meshLog('wjk ??', arr,value,info);
    return info;
}


//判断新定时名称是否重复
export const judgeWeekNameExist = (name) => {
    let arr = JSON.parse(SPGet("sceneList"))
    for (let i = 0; i < arr.length; i++) {
        if(arr[i].name==name){
            return true;;
        }
    }
    return false;
}

//周计划ID 1~150
function getWeekId(){
    let arr = JSON.parse(SPGet("sceneList"))
    let addPos=1;
    for(let k=1;k<=150;k++){
        let isExist=false;
        for (let i = 0; i < arr.length; i++) {
            if(arr[i].sceneID==k){
                isExist=true;
            }
        }
        if(!isExist){
            addPos=k;
            break;
        }
    }
    return addPos
}

//场景ID 0~127
function getSceneId(){
    let arrD = JSON.parse(SPGet("sceneList"))
    let arr=[];
    let nn=0;
    for (let i = 0; i < arrD.length; i++) {
        arr[nn]={ 'sceneID': arrD[i].sceneID };
        nn++;
    }

    let addPos=1;
    for(let k=0;k<=127;k++){
        let isExist=false;
        for (let i = 0; i < arr.length; i++) {
            if(arr[i].sceneID==k){
                isExist=true;
            }
        }
        if(!isExist){
            addPos=k;
            break;
        }
    }
    return addPos
}


//获取maxdim
export const getMaxDim = () => {
    let arr = [];
    for (let i = 0; i < 100; i++) {
        arr[i] = { value: i,'label': (i+1)+"%"}  
    }
    return arr;
}

//获取holdTime
export const getHoldTime = () => {
    let arr = [];
    arr[0] = { value: 0,'label': "5s"}  
    arr[1] = { value: 1,'label': "30s"}  
    for (let i = 1; i <= 120; i++) {
        arr[i+1] = { value: i+1,'label': i+"min"}  
    }
    return arr;
}

//获取Standby dim
export const getStandbyDim = () => {
    let arr = [];
    for (let i = 0; i < 100; i++) {
        arr[i] = { value: i,'label': (i+1)+"%"}  
    }
    return arr;
}

//获取Standby Period
export const getStandbyPeriod = () => {
    let arr = [];
    arr[0] = { value: 0,'label': "0s"}  
    arr[1] = { value: 1,'label': "5s"}  
    arr[2] = { value: 2,'label': "30s"}  
    for (let i = 1; i <= 120; i++) {
        arr[i+2] = { value: i+2,'label': i+"min"}  
    }
    arr[123] = { value: 123,'label': "∞"}  
    return arr;
}
//Daylight Threshold
export const getDaylightThresholdLux = () => {
    let arr = [];
    for (let i = 1; i <= 40; i++) {
        arr[i-1] = { value: i-1,'label': (i*50)+""}  
    }
    return arr;
}
export const getDaylightThresholdFc = () => {
    let arr = [];
    for (let i = 1; i <= 40; i++) {
        arr[i-1] = { value: i-1,'label': (i*5)+""}  
    }
    return arr;
}




//---------------------------------应急电源相关------------------------------------------
//判断是否存在
export const judgeEmergencyExist = () => {
    let sche = JSON.parse(SPGet("sceneList"))
    
    let exist1=false;
    let exist2=false;
    let exist3=false;
    for(let i=0;i<sche.length;i++){
        if(sche[i].sceneMode==parseInt('10D1', 16)){ 
            if(sche[i].sceneValue==1 || sche[i].sceneValue==2 || sche[i].sceneValue==3){
                saveEmergencyLocal(sche[i].time,sche[i].sceneID,sche[i].sceneValue,sche[i].groupIDs,sche[i].repeatMode,sche[i].repeatWeek,false);
            }
            
            if(sche[i].sceneValue==1){
                exist1=true;
            }else if(sche[i].sceneValue==2){
                exist2=true;
            }else if(sche[i].sceneValue==3){
                exist3=true;
            }
        }
    }
    if(!exist1){
        saveEmergencyLocal(600,getSceneId(),1,[],0,0,true);
    }
    if(!exist2){
        saveEmergencyLocal(600,getSceneId(),2,[],0,0,true);
    }
    if(!exist3){
        saveEmergencyLocal(600,getSceneId(),3,[],0,0,true);
    }
}

function saveEmergencyLocal(time,sceneID,sceneValue,groupIDs,repeatMode,repeatWeek,isAdd){
    let sche={"name":"","time":time,"sceneID":sceneID,"sceneMode":parseInt('10D1', 16),"sceneValue":sceneValue,"groupIDs":groupIDs,"repeatMode":repeatMode,"repeatWeek":repeatWeek,"isAdd":isAdd};
    SPSet("edit_schedule_emer"+sceneValue, JSON.stringify(sche));
}

//获取定时json
export const getEmergencyInfo =(mId)=> {
    let sceneValue=parseInt(SPGet("emergencyNmber"));
    if(mId>0){
        sceneValue=mId;
    }
    let json = JSON.parse(SPGet("edit_schedule_emer"+sceneValue))
    return json;
}
//展示信息内容
export const getEmergencyDetailStr=(sche,type)=>{
    if(type=="time"){
        return "Start Time: "+parseInt(sche.time/60)+":"+transIntTo2Str(sche.time%60);
    }else if(type=="week"){
        let msg="";
        if(sche.repeatMode==1){
            msg="Monday";
        }else if(sche.repeatMode==2){
            msg="Tuesday‌";
        }else if(sche.repeatMode==4){
            msg="Wednesday‌";
        }else if(sche.repeatMode==8){
            msg="Thursday‌";
        }else if(sche.repeatMode==16){
            msg="Friday‌";
        }else if(sche.repeatMode==32){
            msg="Saturday‌";
        }else if(sche.repeatMode==64){
            msg="Sunday‌";
        }
        return "Schedule Date: "+msg;
    }else if(type=="repet"){
        return "Repeat: "+sche.repeatWeek+" Week";
    }
}
//编辑定时--time
export const editEmergencyTime = (time,week,repet) => {
    let sche = getEmergencyInfo(0);
    sche.name="";
    sche.time=time;
    sche.sceneID=getSceneId();
    sche.sceneMode=parseInt('10D1', 16); //网关
    sche.sceneValue=parseInt(SPGet("emergencyNmber"));  //item1～3
    sche.groupIDs=[];
    sche.repeatMode=week; //依照App来
    sche.repeatWeek=repet; //profile存1～4， 指令执行0～3

    meshLog("wjk 编辑定时 time");

    let list = JSON.parse(SPGet("sceneList"))
    list[list.length]=sche;

    SPSet("sceneList", JSON.stringify(list))
    PubSub.publish(SET_Emergency_DIALOG_HIDE, '');

    //不要发指令
    uploadNewScheduleData(list);
}
//编辑定时--group
export const editEmergencyGroup = (group) => {
    let sche = getEmergencyInfo(0);
    sche.groupIDs=group;
    meshLog("wjk 编辑定时 group",group);

    let list = JSON.parse(SPGet("sceneList"))
    for(let i=0;i<list.length;i++){
        if(list[i].sceneMode==parseInt('10D1', 16)){ 
            if(list[i].sceneValue==sche.sceneValue){
                list[i].groupIDs=group;
            }
        }
    }

    SPSet("sceneList", JSON.stringify(list))
    PubSub.publish(SET_Emergency_DIALOG_HIDE, ''); //仅更新使用

    sendOpcode_schedule_state(sche,Opcode_edit);
    uploadNewScheduleData(list);
}

//删除定时
export const deleteEmergencyInfo = () => {
    let sche = getEmergencyInfo(0);
    sche.name="";
    sche.time=600;
    // sche.sceneID=sceneID;
    sche.sceneMode=parseInt('10D1', 16); //网关
    sche.sceneValue=parseInt(SPGet("emergencyNmber"));  //item1～3
    sche.groupIDs=[];
    sche.repeatMode=1; //默认周一
    sche.repeatWeek=1; //profile存1～4， 指令执行0～3

    meshLog("wjk 删除定时 ");

    let list = JSON.parse(SPGet("sceneList"))
    let arr=[];
    let count=0;
    for(let i=0;i<list.length;i++){
        let isDel=false;
        if(list[i].sceneMode==parseInt('10D1', 16)){
            if(list[i].sceneValue==sche.sceneValue){
                isDel=true;
            }
        }
        if(!isDel){
            arr[count]=list[i];
            count++;
        }
    }
    sendOpcode_schedule_state(sche,Opcode_delete);
    uploadNewScheduleData(arr);
}

















